module.exports = __webpack_public_path__ + "static/media/none_avatar.38ac2717.png";